export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-1920w.d17f7862.png";